export const reArrangeMenuModalTranslationEN = {
  ReArrangeMenuModal: {},
};
